import React from "react";
import PropTypes from "prop-types";

const getRoundedBarPath = (x, y, width, height, r) => {
  const radius = Math.min(r, width / 2, height / 2);
  return `
    M${x},${y + radius}
    A${radius},${radius} 0 0 1 ${x + radius},${y}
    H${x + width - radius}
    A${radius},${radius} 0 0 1 ${x + width},${y + radius}
    V${y + height}
    H${x}
    Z
  `;
};

const CustomBarShape = (props) => {
  const { x, y, width, height, fill, payload, dataKey, renderedSegments } = props;

  const segments = renderedSegments || ['recurring', 'unique', 'external'];

  const visibleSegments = segments.filter((key) => payload[key] > 0);
  if (visibleSegments.length === 0) return null;

  const topSegment = visibleSegments[visibleSegments.length - 1];
  const isTop = dataKey === topSegment;
  
  const radius = 9;

  if (!isTop) {
    return <rect x={x} y={y} width={width} height={height} fill={fill} />;
  }

  if (isTop) {
    const path = getRoundedBarPath(x, y, width, height, radius);
    return <path d={path} fill={fill} />;
  }

  return null;
};

CustomBarShape.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  payload: PropTypes.object,
  dataKey: PropTypes.string,
  renderedSegments: PropTypes.arrayOf(PropTypes.string),
};

export default CustomBarShape;